import { ArrowRight, CheckCircle, MoveLeft, XCircle } from 'lucide-react'
import React from 'react'
import ThemeChanger from '../ThemeChanger'
import Bg from '../background/Bg'

export default function QuizPageLoader({ currentQuestionCount = 0, totalQuestions = 0 }) {
  const isGeneratingRoadmap = currentQuestionCount > totalQuestions;

  return (
    <div className="min-h-screen bg-base-200 w-screen flex flex-col items-center justify-start p-4 relative">
      <Bg />
      <div className="w-full max-w-4xl flex flex-col items-center gap-6 absolute z-[10]">
        <div className="w-full flex flex-col md:flex-row md:justify-between items-center gap-3">
          <div className="bg-base-100 p-3 text-md font-poppins border border-base-300 rounded-lg w-full md:w-auto text-center shadow-md">
            <p>Question No: <span className="text-info font-semibold">{currentQuestionCount}</span> / {totalQuestions}</p>
          </div>
          <div className="bg-base-100 p-3 text-md font-poppins border border-base-300 rounded-lg w-full md:w-auto text-center shadow-md">
            <p>Topic: <span className="text-primary font-semibold">Loading...</span></p>
          </div>
          <div className="bg-base-100 p-3 text-md font-poppins border border-base-300 rounded-lg w-full md:w-auto text-center shadow-md">
            <ThemeChanger />
          </div>
        </div>
        <div className="w-full bg-base-100 border border-base-300 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
          {isGeneratingRoadmap ? (
            <div className="flex flex-col items-center justify-center py-12">
              <div className="radial-progress animate-spin text-primary" style={{ "--value": "70", "--size": "5rem", "--thickness": "0.5rem" }}></div>
              <h2 className="text-2xl font-bold mt-8 mb-4 text-center text-primary">
                Gathering Your Results
              </h2>
              <p className="text-lg text-center text-base-content/70 max-w-md">
                We're analyzing your answers and generating your personalized learning roadmap...
              </p>
            </div>
          ) : (
            <>
              <p className="text-center mb-4 text-xl font-bold">Loading your next question...</p>
              <div className="flex flex-col gap-3">
                {Array.from({ length: 4 }).map((_, index) => (
                  <div key={index} className="w-full h-14 bg-base-100 animate-pulse rounded-md border border-base-300 shadow-sm"></div>
                ))}
              </div>
              <div className="flex justify-center items-center mt-6">
                <div className="h-12 w-48 bg-base-100 rounded-md animate-pulse border border-base-300 shadow-sm"></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
